module.exports = __webpack_public_path__ + "media/next_game_start_3.998a6e2f.mp3";